import React from "react";
export default class WSComunicator extends React.Component {
  ws = new WebSocket("ws://localhost:8181/");

  WSLogin = () => {
    try {
      this.ws.send("WSS:XrOg0oIYjx5Scmt6fhDjIqPsRll1qnM36NEgSIYp");
    } catch {}
  };

  WSOpen = () => {
    try {
      this.ws = new WebSocket("ws://localhost:8181/");
      this.ws.onopen = (e) => {

      };
      return true;
    } catch (err) {
      return false;
    }
  };

   componentDidMount() {
    this.WSLogin();
  }

  render() {
    this.ws !== null &&
      (this.ws.onmessage = (e) => {
        let urlRedirect = e.data;
        if (urlRedirect) {
          if (
            urlRedirect.indexOf("https://www.britex.cz") > -1 ||
            urlRedirect.indexOf("http://localhost:3000") > -1
          ) {
            window.location.assign(urlRedirect);
          }
        }
      });
    return <></>;
  }
}
